































































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import Vue2TouchEvents from 'vue2-touch-events'
import { IProduct } from '~/assets/interfaces/products'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentProductDetailPricesLight from '~/components/products/product-detail-prices-light.vue'
Vue.use(Vue2TouchEvents)

@Component({
  components: {
    LazyHydrate,
    ComponentImage,
    ComponentProductDetailPricesLight,
    ComponentCatalogLabels,
  },
})
export default class ComponentProductItem2 extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IProduct

  private isHiddenImageLazyLoad = false

  private get styleImage() {
    let temp = {}
    if (this.item.ratio) {
      temp = Object.assign(temp,{    paddingTop: ((1 / eval(this.item.ratio)) * 100).toString() + '%', // eslint-disable-line
      })
    }

    if (this.item.imageLazyLoad && !this.isHiddenImageLazyLoad) {
      temp = Object.assign(temp, {
        backgroundImage: `url("${this.item.imageLazyLoad}")`,
      })
    }
    return temp
  }

  private imageNumber = 0

  private get imagesAmount() {
    return this.item.images ? this.item.images.length : 0
  }

  private hover(num: number) {
    this.isHiddenImageLazyLoad = true
    let numTemp = num
    if (numTemp > this.imagesAmount) {
      numTemp = this.imagesAmount
    }
    this.imageNumber = numTemp - 1
  }

  private swipeMobile(direction: string) {
    if (direction === 'left') {
      this.hover(this.imageNumber + 2)
    }
    if (direction === 'right') {
      this.hover(this.imageNumber)
    }
  }

  private mounted(): void {
    this.$emit('loaded')
  }

  get imageAlt() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.alt) {
      return this.item.imageMeta.alt
    }
    return null
  }

  get imageTitle() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }

    if (this.item.imageMeta.title) {
      return this.item.imageMeta.title
    }
    return null
  }
}
